import { ReactComponent as LoansGridIcon } from "assets/images/v2/nav-desktop-home.svg";
import { useLoanSidebarData } from "hooks/useLoanSidebarData";
import { useNavigate } from "react-router-dom";
import SidebarNavItem from "./SidebarNavItem";
import { useMainNavActiveState } from "./useMainNavActiveState";

export default function SidebarLoansLink() {
  const navigate = useNavigate();
  const { isLoansActive } = useMainNavActiveState();
  const { portfolioLoanCount, isLoading } = useLoanSidebarData();

  if (!isLoading && portfolioLoanCount === 1) {
    return null;
  }

  return (
    <SidebarNavItem
      label="Loans"
      icon={<LoansGridIcon />}
      isActive={isLoansActive}
      onClick={() => navigate("/my-loans")}
    />
  );
}
